import React from 'react';
import { IDialog } from './interfaces';
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
  CustomTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const Dialog: React.FC<IDialog> = ({
  title,
  subTitle,
  children,
  buttons,
  show = true,
  minWidth = '500px',
  maxWidth,
  onClose,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  return (
    <MuiDialog
      open={show}
      onClose={onClose}
      maxWidth={maxWidth}
      slotProps={{
        paper: {
          sx: {
            minWidth,
            width: '100%',
            ...(maxWidth === false && {
              maxWidth: minWidth,
            }),
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          position: 'relative',
        }}
      >
        <Typography variant="h2" fontSize="1.2rem" fontWeight="bold">
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="body2" color="text.secondary">
            {subTitle}
          </Typography>
        )}

        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon
            sx={{
              width: '20px',
              height: '20px',
            }}
          />
        </IconButton>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      {buttons && (
        <DialogActions
          sx={{
            backgroundColor: '#FBF9F7',
            borderTop: `1px solid ${theme.palette.grey[200]}`,
            width: '100%',
            boxSizing: 'border-box',
            '& > *:only-child': {
              width: '100%',
            },
          }}
        >
          {buttons}
        </DialogActions>
      )}
    </MuiDialog>
  );
};
